import { useMutation } from '@tanstack/react-query';
import { MutationKey } from '@shared/config';
import { authApi } from '../../authApi';
import type { RegistrationPreflightRequest } from '../../types';

export const useRegisterVerification = () =>
  useMutation({
    mutationKey: [MutationKey.AUTH_REGISTER_VERIFICATION],
    mutationFn: (payload: RegistrationPreflightRequest) =>
      authApi.prepareRegistration(payload),
  });
